/*
 * @Author: liujunhong
 * @Date: 2022/12/9
 * @Desc: 
 */


import React, {Suspense, useState} from "react";
import SecondHeader from "../components/SecondHeader";
import {Route, Switch} from "react-router-dom";
import routes from "../consts/route";

const Routes = (props) => {
  const [shopCarNum, setShopCarNum] = useState(0);
  return <>
    <SecondHeader num={shopCarNum}/>
    <Suspense fallback={<div className='loading'>加载中...</div>}>
      <Switch >
        {
          routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                name={route.name}
                render={props => {
                  return <route.component {...props} num={setShopCarNum}/>
                }}/>
            )
          })
        }
      </Switch>
    </Suspense>
  </>
}

export default Routes